import { render, staticRenderFns } from "./ProWorksheetPhysicalExam.vue?vue&type=template&id=5d74b478&scoped=true&"
import script from "./ProWorksheetPhysicalExam.vue?vue&type=script&lang=js&"
export * from "./ProWorksheetPhysicalExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d74b478",
  null
  
)

export default component.exports